import React from "react";

function MovableSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 13 12"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.192 4.291h10.421M5.305 1L4.208 4.291l2.194 6.308L8.596 4.29 7.5 1m-.76 9.469l4.914-5.897c.084-.1.125-.15.141-.206a.273.273 0 000-.15c-.016-.056-.057-.106-.14-.206L9.275 1.158c-.048-.058-.072-.087-.102-.108a.274.274 0 00-.086-.04C9.053 1 9.015 1 8.939 1H3.865c-.075 0-.113 0-.148.01a.274.274 0 00-.087.04c-.03.02-.053.05-.102.108L1.151 4.01c-.083.1-.125.15-.14.206a.274.274 0 000 .15c.015.056.057.106.14.206l4.914 5.897c.116.139.174.208.243.233.061.023.128.023.188 0 .07-.025.128-.095.243-.233z"
      ></path>
    </svg>
  );
}

export default MovableSvg;
